import React from "react";

export default function ValentineFrame7({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 2000 2000"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {".cls7-1{fill:#c66a54}.cls7-2{fill:#311b15}.cls7-3{fill:#fea1bf}"}
          </style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_3"
          data-name="\u0421\u043B\u043E\u0439 3"
        >
          <path
            className="cls7-1"
            d="M1446.77 1123.57a503.7 503.7 0 0 0-46.35-173.36c-74-156.49-225.51-263.76-400.41-263.76-186 0-345.49 121.25-413.51 294a506 506 0 0 0-33.26 143.1 531.25 531.25 0 0 0-1.81 43.56c0 205.86 120.78 381.51 290.56 450a422.29 422.29 0 0 0 316 0c169.78-68.48 290.55-244.13 290.55-450q.04-22-1.77-43.54Zm-148 324.77a95.42 95.42 0 0 1-95.42 95.42H796.71a95.43 95.43 0 0 1-95.43-95.42v-406.6a95.44 95.44 0 0 1 95.43-95.43h406.6a95.43 95.43 0 0 1 95.42 95.43Z"
          />
          <path
            className="cls7-1"
            d="M1466.2 758.05c0 70.06-24 135.72-65.78 192.16-27 36.45-61.43 69-101.69 96.53v-5a95.43 95.43 0 0 0-95.42-95.43h-406.6a95.44 95.44 0 0 0-95.43 95.43v28.47c-44.31-24.66-83.15-55-114.78-89.74-57.1-62.63-90.71-139.47-90.71-222.42 0-211 217.23-382 485.2-382s485.21 171.02 485.21 382Z"
          />
          <circle className="cls7-1" cx={654.21} cy={431.14} r={201.82} />
          <path
            className="cls7-2"
            d="M783.4 410.41c-2.07 8.38-9.28 7.62-41.64 30.78-36 25.8-34 31.73-53.65 40.36-27.86 12.26-37.16 2.6-57.65 16.17-23 15.24-21.91 34.46-33.8 35.61-19.62 1.89-52.37-47.6-48.77-95.84 4-53.31 52.42-105.62 110.63-110.62C727.5 321 790.1 383.22 783.4 410.41Z"
          />
          <circle className="cls7-1" cx={1345.8} cy={423.62} r={201.82} />
          <circle className="cls7-2" cx={864.6} cy={712.28} r={25.83} />
          <circle className="cls7-2" cx={1112.98} cy={712.28} r={25.83} />
          <ellipse
            className="cls7-2"
            cx={1000.01}
            cy={786.48}
            rx={43.9}
            ry={19.46}
          />
          <circle className="cls7-3" cx={696.05} cy={799.43} r={59.34} />
          <circle className="cls7-3" cx={1303.96} cy={799.43} r={59.34} />
          <path
            className="cls7-1"
            d="M872.32 1543.76a335.43 335.43 0 0 1-30.32 73.36c-54.14 96.42-153.82 161.09-267.85 161.09-171.72 0-310.95-146.71-310.95-327.69 0-173.59 128.08-315.64 290.05-327q10.38-.75 20.9-.74a296.55 296.55 0 0 1 127.14 28.55v297a95.43 95.43 0 0 0 95.43 95.42ZM1736.81 1450.52c0 181-139.21 327.69-311 327.69-114 0-213.69-64.67-267.83-161.09a335.48 335.48 0 0 1-30.35-73.36h75.63a95.42 95.42 0 0 0 95.42-95.42v-297a296.54 296.54 0 0 1 127.13-28.55q10.53 0 20.91.74c162.05 11.37 290.09 153.47 290.09 326.99Z"
          />
          <path
            className="cls7-2"
            d="M1041.53 840.57c-14.18 0-30.32-11.33-41.51-29.62-12.93 21.21-33.71 32.86-51.74 28.56-7-1.67-13.61-5.91-19.11-12.26A2.5 2.5 0 1 1 933 824c4.81 5.56 10.51 9.25 16.49 10.68 16.88 4 36.77-8.27 48.36-29.89l2.19-4.07 2.21 4c11.74 21.49 31.16 34.38 45.18 30 4.37-1.38 8.3-4.51 11.68-9.31a2.5 2.5 0 1 1 4.09 2.88c-4 5.72-8.82 9.49-14.27 11.2a24.16 24.16 0 0 1-7.4 1.08ZM1203.31 1546.26h-406.6a98 98 0 0 1-97.93-97.92v-406.6a98 98 0 0 1 97.93-97.93h406.6a98 98 0 0 1 97.92 97.93v406.6a98 98 0 0 1-97.92 97.92Zm-406.6-597.45a93 93 0 0 0-92.93 92.93v406.6a93 93 0 0 0 92.93 92.92h406.6a93 93 0 0 0 92.92-92.92v-406.6a93 93 0 0 0-92.92-92.93Z"
          />
          <ellipse
            className="cls7-1"
            cx={627.29}
            cy={1065.15}
            rx={155.7}
            ry={198.68}
            transform="rotate(-70.62 627.24 1065.123)"
          />
          <ellipse
            className="cls7-1"
            cx={1364.88}
            cy={1065.15}
            rx={198.68}
            ry={155.7}
            transform="rotate(-19.38 1365.12 1065.267)"
          />
          <path
            className="cls7-2"
            d="M655.87 1231.93q-6.11 0-12.34-.34a249.81 249.81 0 0 1-65.53-12.73c-52.73-17.65-87.93-51.22-108.16-76.28a2.5 2.5 0 0 1 3.89-3.14c19.81 24.54 54.27 57.41 105.86 74.67 29.71 10 106 28.48 172.62-14.12 14.18-9.07 57.35-36.69 67.78-87.62C832.14 1053 791.73 1004 778.45 988c-74.82-90.55-208.3-78-234.3-74.58a2.5 2.5 0 0 1-.65-5 355.82 355.82 0 0 1 95.89 1.58c61.75 9.58 109.84 34.74 142.91 74.77 13.66 16.53 55.22 66.83 42.58 128.59-10.85 53-55.36 81.48-70 90.83-28.78 18.43-62.05 27.73-99.01 27.74ZM1337 1231.93c-37 0-70.22-9.31-99-27.73-14.63-9.35-59.13-37.82-70-90.83-12.64-61.75 28.92-112.06 42.58-128.59 33.08-40 81.16-65.19 142.91-74.77a355.9 355.9 0 0 1 95.9-1.58 2.5 2.5 0 0 1-.66 5c-26-3.44-159.48-16-234.3 74.58-13.28 16.07-53.69 65-41.53 124.4 10.43 50.93 53.6 78.55 67.79 87.62 66.6 42.6 142.9 24.07 172.62 14.12 51.58-17.26 86-50.13 105.86-74.67a2.5 2.5 0 0 1 3.89 3.14c-20.24 25.06-55.43 58.63-108.17 76.28a249.73 249.73 0 0 1-65.54 12.73q-6.24.29-12.35.3ZM1216.62 410.41c2.06 8.38 9.28 7.62 41.64 30.78 36 25.8 34 31.73 53.64 40.36 27.87 12.26 37.17 2.6 57.66 16.17 23 15.24 21.91 34.46 33.8 35.61 19.62 1.89 52.37-47.6 48.76-95.84-4-53.31-52.42-105.62-110.62-110.62-68.99-5.87-131.58 56.35-124.88 83.54Z"
          />
          <path
            className="cls7-3"
            d="M1168.22 394.57a107.64 107.64 0 0 0-19.86-50c-5.18-7.12-32.3-44.36-65.37-42.77-37.09 1.77-62.55 51.47-46.58 81 8.07 14.92 25.11 21.75 37.81 26.84 36 14.43 67.73 7.64 80.08 4.26ZM1170.59 394.43a104.56 104.56 0 0 1 47.58-22.67c8.41-1.62 52.47-10.06 74.47 13.76 24.68 26.73 8.9 80.28-22.19 90.78-15.69 5.31-32.19-1.42-44.49-6.43-34.84-14.19-52.41-40.9-58.75-51.83l3.38-23.61Z"
          />
          <path
            d="M1184.74 380.8a23 23 0 0 0-18.46-6.77 98 98 0 0 0-18.66 32.22 96.41 96.41 0 0 0-4 16.38c2.58 7 8.59 11.61 14.85 11.54a14.71 14.71 0 0 0 9.37-3.84 147.31 147.31 0 0 0 17-49.53Z"
            style={{
              fill: "#e98ead",
            }}
          />
          <path
            className="cls7-2"
            d="M642.11 1446.84c-7.41-15.92-26.87-35-52.5-37.72-22.87-2.43-46.22 8.65-63 28.82-19.73-17.26-44.54-24.51-66.73-18.49-24.88 6.74-41.05 28.66-45.88 45.55-12.57 44.29 37.75 108.18 127.12 156h.15c80.73-61.36 120.27-132.42 100.84-174.16ZM1357.9 1446.84c7.42-15.92 26.88-35 52.51-37.72 22.87-2.43 46.22 8.65 63 28.82 19.73-17.26 44.53-24.51 66.73-18.49 24.88 6.74 41.08 28.66 45.88 45.56 12.57 44.29-37.76 108.18-127.12 156h-.15c-80.7-61.37-120.27-132.43-100.85-174.17Z"
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
